import {until} from 'lit-html/directives/until';

export default (ctx, html) => html`
<form @submit="${ctx.submit}" novalidate autocomplete="on" method="post">
  <div class="form-group">
    <label for="exampleInputEmail1">${until(ctx.__('<tt-SpUxykTH>', 'Title of the Report'))}</label>
    <input type="email" class="form-control ${!ctx.form.title.valid ? 'is-invalid': ''}" name="title" @input="${ctx.updateTitle}" @blur="${ctx.validateTitle}">
  </div>
  <div class="form-group mb-5">
    <label for="exampleInputPassword1">${until(ctx.__('<tt-lXbse73E>', 'Description of the Report (optional)'))}</label>
    <textarea class="form-control" name="description" @blur="${ctx.updateDescription}" rows="6"></textarea>
  </div>
  <div class="form-group">
    <div class="row">
      <div class="col-6 col-sm-4 offset-sm-2">
        <button type="button" class="btn rounded-pill btn-outline-primary btn-block" @click="${ctx.cancel}">
            ${until(ctx.__('<tt-GjHcxFwW>', 'Cancel'))}
        </button>
      </div>
      <div class="col-6 col-sm-4">
        <button type="submit" class="btn btn-block btn-primary rounded-pill" ?disabled="${!ctx.form.valid || ctx.saving}">
          ${ctx.saving? html`
            <div class="spinner-border mr-3" role="status">
              <span class="sr-only">${until(ctx.__('<tt-I613q1U4>', 'Saving...', 'Screen reader text'))}</span>
            </div>${until(ctx.__('<tt-dp8Z2rdc>', 'Saving...'))}`
          : html`
             ${until(ctx.__('<tt-1S5bnckk>', 'OK'))}
          `}
        </button>
      </div>
    </div>
  </div>
</form>
`;
